import React from 'react';
import {
    Box,
    Button,
    CircularProgress,
} from '@mui/material';
import {
    NavigateBefore as PreviousIcon,
    NavigateNext as NextIcon,
    Check as CheckIcon,
} from '@mui/icons-material';

const QuestionNavigation = ({ 
    currentQuestionIndex, 
    questions, 
    onQuestionChange, 
    onSubmitSection,
    isLastSection,
    submitting,
    answers,
    canSubmit 
}) => {
    const isLastQuestion = currentQuestionIndex === questions.length - 1;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, mt: 2 }}>
            {/* Question Number Buttons */}
            <Box sx={{ 
                display: 'flex', 
                gap: 1, 
                justifyContent: 'center', 
                flexWrap: 'wrap',
            }}>
                {questions.map((q, index) => (
                    <Button
                        key={q.id}
                        variant={index === currentQuestionIndex ? "contained" : "outlined"}
                        size="small"
                        onClick={() => onQuestionChange(index)}
                        disabled={submitting}
                        sx={{
                            minWidth: 40,
                            height: 40,
                            backgroundColor: answers[q.id] !== undefined 
                                ? (index === currentQuestionIndex ? 'primary.main' : 'success.light')
                                : undefined,
                            borderRadius: '50%',
                            color: answers[q.id] !== undefined && index !== currentQuestionIndex ? 'text.primary' : 'inherit',
                            '&:hover': {
                                backgroundColor: answers[q.id] !== undefined ? 'primary.dark' : 'action.hover'
                            }
                        }}
                    >
                        {index + 1}
                    </Button>
                ))}
            </Box>

            {/* Navigation Buttons */}
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', width: '100%' }}>
                {/* Previous Button */}
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => onQuestionChange(currentQuestionIndex - 1)}
                    disabled={currentQuestionIndex === 0 || submitting}
                    startIcon={<PreviousIcon />}
                    sx={{ flexGrow: { xs: 1, sm: 0 }, minWidth: '120px' }}
                >
                    Previous
                </Button>

                {/* Next/Submit Button */}
                {isLastQuestion ? (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onSubmitSection}
                        disabled={submitting || !canSubmit}
                        startIcon={submitting ? <CircularProgress size={20} color="inherit" /> : 
                            (isLastSection ? <CheckIcon /> : <NextIcon />)}
                        sx={{ 
                            fontWeight: 'bold',
                            flexGrow: { xs: 1, sm: 0 },
                            minWidth: '120px'
                        }}
                    >
                        {submitting ? 'Submitting...' : 
                            (isLastSection ? 'Complete Quiz' : 'Next Section')}
                    </Button>
                ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => onQuestionChange(currentQuestionIndex + 1)}
                        disabled={submitting}
                        endIcon={<NextIcon />}
                        sx={{ flexGrow: { xs: 1, sm: 0 }, minWidth: '120px' }}
                    >
                        Next
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default QuestionNavigation;
